import { Tabs, Tab, Box, IconButton, Menu, MenuItem, Button } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import moment from 'moment';
import React, { SyntheticEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import SearchBar from '../../components/SearchBar';
import { showError, showToast } from '../../constants/toasts';
import ApprovedDealersStoreList from '../../features/dealersStore/approvedDealersStoreList';
import NewDealersStoreList from '../../features/dealersStore/newDealersStoreList';
import RejectedDealersStoreList from '../../features/dealersStore/rejectedDealersStoreList';
import MainContainer from '../../layout/MainContainer';
import { ConfirmationModal } from '../../Modals/confirmationModal';
import {
  useDeleteStoreMutation,
  useLazyGetAllStoresQuery,
  useUpdateStoreMutation,
} from '../../service/store';
import { CommonBody, Store } from '../../types/General';
import { generateEncryptedKeyBody } from '../../utils/crypto';
import { APPROVAL_STATUS } from '../../utils/enums';
// import {
//   useLazyDeleteUserQuery,
//   useLazyGetstoresQuery,
//   useUpdateUserProfileMutation,
// } from "../../service/auth";
import { isValidInput } from '../../utils/validations';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const ManageStore = () => {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState<string>('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>('');
  const [valueTabs, setValueTabs] = useState(APPROVAL_STATUS.PENDING);
  const [newstores, setPendingStore] = useState<number>(0);
  const [approvedStores, setApprovedStores] = useState<number>(0);
  const [rejectedStores, setRejectedStores] = useState<number>(0);
  const [selectedId, setSelectedId] = useState('');
  const [open, setOpen] = useState(false);
  const [modalType, setModalType] = useState('');

  const [getStores] = useLazyGetAllStoresQuery();
  const [deleteStore] = useDeleteStoreMutation();
  // const [updateUser] = useUpdateUserProfileMutation();
  const [updatedStore] = useUpdateStoreMutation();

  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [stores, setStore] = useState<Store[]>([]);
  const [page, setPage] = useState<number>(1);

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const handleChangeTabs = (event: SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);

  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>, rowId: string) => {
    setAnchorEl1(event.currentTarget);
    setSelectedId(rowId);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
    setSelectedId('');
  };

  const columns: GridColDef<(typeof stores)[number]>[] = [
    {
      flex: 0.8,
      minWidth: 200,
      field: 'name',
      headerName: 'Owner Details',
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure onClick={() => navigate(`/profile-detail/dealer/${row?._id}`)}>
              <img src={row?.image || '/static/images/user_placeholder.png'} alt="" />
            </figure>
            <p>
              <b>{row?.user?.name || '-'}</b>
              {row?.user?.dialCode} {row?.user?.phoneNo || '-'} <br />
              {row?.user?.email || '-'}
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 300,
      field: 'storeName',
      headerName: 'Store Name',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.storeName || '-'}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 300,
      field: 'address',
      headerName: 'Address',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.addressObject?.address || '-'}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 300,
      field: 'openingTime',
      headerName: 'Opening Time',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{moment(row?.openingTime).format('lll') || '-'}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 300,
      field: 'closingTime',
      headerName: 'Closing Time',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{moment(row?.closingTime).format('lll') || '-'}</p>
          </div>
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: 'action',
      headerName: 'Action',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? 'basic-menu1' : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? 'true' : undefined}
                onClick={(event) => handleClick1(event, row._id)}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  'aria-labelledby': 'basic-button1',
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.05)',
                    borderRadius: '8px',
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <MenuItem
                  onClick={() => {
                    if (selectedId) {
                      setModalType('accept');
                      setAnchorEl1(null);
                      setOpen(true);
                    }
                  }}
                >
                  Approve
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    if (selectedId) {
                      setAnchorEl1(null);
                      setModalType('reject');
                      setOpen(true);
                    }
                  }}
                >
                  Reject
                </MenuItem>
                <MenuItem onClick={() => navigate(`/manage-store/view/${selectedId}`)}>
                  View
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    handleDelete();
                    // navigate(`//dealer/${selectedId}`)
                  }}
                >
                  Delete
                </MenuItem>
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  const handleDelete = async () => {
    setLoading(true);
    try {
      const response = await deleteStore({
        id: selectedId,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        showToast('Deleted successfully');
        // getstoresList();
        getStoreList();
      } else {
        setStore([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
      setLoading(false);
    }
  };

  // const handleUserUpdate = async (id: string, status: any, type: string) => {
  //   const body = {
  //     ...(type === UPDATE_TYPES.BLOCK ? { isBlocked: status } : {}),
  //   };

  //   try {
  //     const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
  //     const response = await updateUser({
  //       body: encryptedBody,
  //       id: id,
  //     }).unwrap();
  //     if (response?.statusCode === 200) {
  //       const updatedData = stores?.map((item) => {
  //         if (item?._id === id) {
  //           return {
  //             ...item,
  //             isBlocked: status,
  //           };
  //         }
  //         return item;
  //       });
  //       setStore(updatedData);
  //       if (status === true) {
  //         showToast("Blocked successfully");
  //       } else {
  //         showToast("Unblocked successfully");
  //       }
  //     } else {
  //       showError("Please try again");
  //     }
  //   } catch (error: any) {
  //     console.error(error, "errror");
  //     showError(error?.data?.message || "");
  //   }
  // };

  const handleApproveReject = async () => {
    const body = {
      status: modalType === 'accept' ? 2 : 3,
    };

    try {
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await updatedStore({
        body: encryptedBody,
        id: selectedId,
      }).unwrap();
      if (response?.statusCode === 200) {
        showToast(
          modalType === 'accept' ? 'Store approved successfully' : 'Store rejected successfully'
        );
        if (modalType === 'accept') {
          setValueTabs(APPROVAL_STATUS.APPROVED);
          setPage(1);
        } else {
          setValueTabs(APPROVAL_STATUS.REJECTED);
          setPage(1);
        }
      } else {
        showError('Please try again');
      }
    } catch (error: any) {
      console.error(error, 'errror');
      showError(error?.data?.message || '');
    }
  };

  const getStoreList = async () => {
    setLoading(true);
    try {
      const response = await getStores({
        page: page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
        status: String(valueTabs + 1),
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        setStore(response?.data?.data || []);
        setCount(response?.data?.count);
        setPendingStore(response?.data?.pendingCount);
        setApprovedStores(response?.data?.approvedCount);
        setRejectedStores(response?.data?.rejectCount);
      } else {
        setStore([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || '');
      setLoading(false);
    }
  };

  useEffect(() => {
    getStoreList();
  }, [debouncedSearchTerm, page, valueTabs]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1> Manage Store</h1>
        <p>
          <span onClick={() => navigate('/dashboard')}>Dashboard</span>
        </p>
      </div>
      <div className="cards">
        <Box className="custom_tabs" sx={{ width: '100%' }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search Stores"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm('')}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            <div className="right_s">
              <Box>
                <Button className="btn btn_highlight">
                  <img src="/static/images/upload_icon.svg" alt="Icon" /> Export CSV
                </Button>
              </Box>
            </div>
          </div>

          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab label={`Pending Store (${newstores})`} {...a11yProps(APPROVAL_STATUS.PENDING)} />
            <Tab
              label={`Approved Store(${approvedStores})`}
              {...a11yProps(APPROVAL_STATUS.APPROVED)}
            />
            <Tab
              label={`Rejected Store(${rejectedStores})`}
              {...a11yProps(APPROVAL_STATUS.REJECTED)}
            />
          </Tabs>

          <CustomTabPanel value={valueTabs} index={APPROVAL_STATUS.PENDING}>
            <NewDealersStoreList
              rows={stores}
              columns={columns}
              count={count}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={APPROVAL_STATUS.APPROVED}>
            <ApprovedDealersStoreList
              count={count}
              rows={stores}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
              setStores={setStore}
              setSelectedId={setSelectedId}
              handleDeleteUser={() => {}}
              handleUserUpdate={() => {}}
              setModalType={setModalType}
              setOpen={setOpen}
              selectedId={selectedId}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={APPROVAL_STATUS.REJECTED}>
            <RejectedDealersStoreList
              count={count}
              rows={stores}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
              setSelectedId={setSelectedId}
              selectedId={selectedId}
              setOpen={setOpen}
              setModalType={setModalType}
            />
          </CustomTabPanel>
        </Box>

        <ConfirmationModal
          text={
            modalType === 'delete'
              ? 'Are you sure to delete this store?'
              : modalType === 'accept'
                ? 'Are you sure to approve this store?'
                : modalType === 'reject'
                  ? 'Are you sure to reject this store?'
                  : ''
          }
          openModal={open}
          setOpenModal={setOpen}
          // handleSubmit={()=>{}}
          handleSubmit={
            modalType === 'accept' || modalType === 'reject'
              ? () => handleApproveReject()
              : () => {}
            // modalType === "delete"
            //   ? handleDeleteUser
            //   : modalType === "accept" || modalType === "reject"
            //   ? () => handleApproveReject()
            //   : () => {}
          }
        />
      </div>
    </MainContainer>
  );
};

export default ManageStore;
